import { AdminPage } from './AdminPage';

interface ComingSoonProps {
  title: string;
  description?: string;
}

/** Placeholder for admin sections that are wired into the nav but not built yet. */
export function ComingSoon({ title, description }: ComingSoonProps) {
  return (
    <AdminPage title={title} description={description}>
      <div className="rounded-xl border border-dashed border-app-border bg-app-card/50 px-6 py-16 flex flex-col items-center text-center gap-3">
        <div className="w-12 h-12 rounded-full bg-gold/12 flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-6 h-6 text-gold">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
          </svg>
        </div>
        <p className="text-sm font-medium text-app-fg">Coming soon</p>
        <p className="text-xs text-app-muted max-w-sm">
          This section is part of the admin roadmap and will be available in a future update.
        </p>
      </div>
    </AdminPage>
  );
}

export default ComingSoon;
